'use strict';

var _PaginationBoxView = require('./PaginationBoxView');

var _PaginationBoxView2 = _interopRequireDefault(_PaginationBoxView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = _PaginationBoxView2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-paginate/dist/index.js
// module id = 623
// module chunks = 0